import { render, staticRenderFns } from "./SedimentResults.vue?vue&type=template&id=8928c7e6&scoped=true"
import script from "./SedimentResults.vue?vue&type=script&lang=js"
export * from "./SedimentResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8928c7e6",
  null
  
)

export default component.exports